import * as constants from "./constants";

// Fetch users list
export const fetchUsersRequest = (params?: any) => ({
    type: constants.FETCH_USERS_REQUESTING, params,
});
export const fetchUsersSuccess = (payload: any) => ({
    type: constants.FETCH_USERS_SUCCESS, payload,
});
export const fetchUsersFailed = (error: any) => ({
    type: constants.FETCH_USERS_FAILED, error,
});

// Create user
export const createUserRequest = (payload: any, callback?: () => void) => ({
    type: constants.CREATE_USER_REQUESTING, payload, callback,
});
export const createUserSuccess = (payload: any) => ({
    type: constants.CREATE_USER_SUCCESS, payload,
});
export const createUserFailed = (error: any) => ({
    type: constants.CREATE_USER_FAILED, error,
});

// Update user
export const updateUserRequest = (id: string, payload: any, callback?: () => void) => ({
    type: constants.UPDATE_USER_REQUESTING, id, payload, callback,
});
export const updateUserSuccess = (payload: any) => ({
    type: constants.UPDATE_USER_SUCCESS, payload,
});
export const updateUserFailed = (error: any) => ({
    type: constants.UPDATE_USER_FAILED, error,
});

// Delete (deactivate) user
export const deleteUserRequest = (id: string, callback?: () => void) => ({
    type: constants.DELETE_USER_REQUESTING, id, callback,
});
export const deleteUserSuccess = (id: string) => ({
    type: constants.DELETE_USER_SUCCESS, id,
});
export const deleteUserFailed = (error: any) => ({
    type: constants.DELETE_USER_FAILED, error,
});

// Fetch roles
export const fetchRolesRequest = () => ({
    type: constants.FETCH_ROLES_REQUESTING,
});
export const fetchRolesSuccess = (payload: any) => ({
    type: constants.FETCH_ROLES_SUCCESS, payload,
});
export const fetchRolesFailed = (error: any) => ({
    type: constants.FETCH_ROLES_FAILED, error,
});

// Create role
export const createRoleRequest = (payload: { name: string; permissions: string[] }, callback?: () => void) => ({
    type: constants.CREATE_ROLE_REQUESTING, payload, callback,
});
export const createRoleSuccess = (payload: any) => ({
    type: constants.CREATE_ROLE_SUCCESS, payload,
});
export const createRoleFailed = (error: any) => ({
    type: constants.CREATE_ROLE_FAILED, error,
});

// Update role
export const updateRoleRequest = (id: number, payload: { permissions: string[] }, callback?: () => void) => ({
    type: constants.UPDATE_ROLE_REQUESTING, id, payload, callback,
});
export const updateRoleSuccess = (payload: any) => ({
    type: constants.UPDATE_ROLE_SUCCESS, payload,
});
export const updateRoleFailed = (error: any) => ({
    type: constants.UPDATE_ROLE_FAILED, error,
});

// Delete role
export const deleteRoleRequest = (id: number, callback?: () => void) => ({
    type: constants.DELETE_ROLE_REQUESTING, id, callback,
});
export const deleteRoleSuccess = (id: number) => ({
    type: constants.DELETE_ROLE_SUCCESS, id,
});
export const deleteRoleFailed = (error: any) => ({
    type: constants.DELETE_ROLE_FAILED, error,
});

// Suspend user
export const suspendUserRequest = (id: string, callback?: () => void) => ({
    type: constants.SUSPEND_USER_REQUESTING, id, callback,
});
export const suspendUserSuccess = (payload: any) => ({
    type: constants.SUSPEND_USER_SUCCESS, payload,
});
export const suspendUserFailed = (error: any) => ({
    type: constants.SUSPEND_USER_FAILED, error,
});

// Activate user
export const activateUserRequest = (id: string, callback?: () => void) => ({
    type: constants.ACTIVATE_USER_REQUESTING, id, callback,
});
export const activateUserSuccess = (payload: any) => ({
    type: constants.ACTIVATE_USER_SUCCESS, payload,
});
export const activateUserFailed = (error: any) => ({
    type: constants.ACTIVATE_USER_FAILED, error,
});

// User detail
export const fetchUserDetailRequest = (id: string) => ({
    type: constants.FETCH_USER_DETAIL_REQUESTING, id,
});
export const fetchUserDetailSuccess = (payload: any) => ({
    type: constants.FETCH_USER_DETAIL_SUCCESS, payload,
});
export const fetchUserDetailFailed = (error: any) => ({
    type: constants.FETCH_USER_DETAIL_FAILED, error,
});
export const clearUserDetail = () => ({
    type: constants.CLEAR_USER_DETAIL,
});

// User stats
export const fetchUserStatsRequest = (id: string) => ({
    type: constants.FETCH_USER_STATS_REQUESTING, id,
});
export const fetchUserStatsSuccess = (payload: any) => ({
    type: constants.FETCH_USER_STATS_SUCCESS, payload,
});
export const fetchUserStatsFailed = (error: any) => ({
    type: constants.FETCH_USER_STATS_FAILED, error,
});

// User activite
export const fetchUserActiviteRequest = (id: string) => ({
    type: constants.FETCH_USER_ACTIVITE_REQUESTING, id,
});
export const fetchUserActiviteSuccess = (payload: any) => ({
    type: constants.FETCH_USER_ACTIVITE_SUCCESS, payload,
});
export const fetchUserActiviteFailed = (error: any) => ({
    type: constants.FETCH_USER_ACTIVITE_FAILED, error,
});

// User decisions
export const fetchUserDecisionsRequest = (id: string) => ({
    type: constants.FETCH_USER_DECISIONS_REQUESTING, id,
});
export const fetchUserDecisionsSuccess = (payload: any) => ({
    type: constants.FETCH_USER_DECISIONS_SUCCESS, payload,
});
export const fetchUserDecisionsFailed = (error: any) => ({
    type: constants.FETCH_USER_DECISIONS_FAILED, error,
});
